//Styles
import { classNames } from "primereact/utils"
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import RenderFormulaConnector from "./RenderFormulaConnector"

export const defaultNewItemId = "newItem"

export default function RenderFormulaNewItem({
  hasFormulas,
  defaultOperator,
  isDragging,
  isDraggingOperator,
}) {
  const NewItemPlaceholder = () => (
    <div className={myStyles.formLayoutBodySpacer}>
      Add new <br />
      item
    </div>
  )

  if (!hasFormulas) {
    return <NewItemPlaceholder />
  }

  return (
    <>
      <div
        className={classNames(myStyles.formulaRenderLayout, {
          [myStyles.formulaRenderLayoutNewItemNoDrag]:
            !isDragging || isDraggingOperator,
          [myStyles.formulaRenderLayoutNewItem]:
            isDragging && !isDraggingOperator,
        })}
      >
        <div className={myStyles.formulaRenderLayoutBodyNewItem}>
          <NewItemPlaceholder />
        </div>
        {isDragging && !isDraggingOperator && (
          <div className={myStyles.formulaRenderLayoutConnector}>
            <RenderFormulaConnector
              connector={defaultOperator}
              formulaId={defaultNewItemId}
              overConnectorId={defaultNewItemId}
            />
          </div>
        )}
      </div>
    </>
  )
}
